import { render, staticRenderFns } from "./SystemMessageManager.vue?vue&type=template&id=65761974&scoped=true"
import script from "./SystemMessageManager.vue?vue&type=script&lang=js"
export * from "./SystemMessageManager.vue?vue&type=script&lang=js"
import style0 from "./SystemMessageManager.vue?vue&type=style&index=0&id=65761974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65761974",
  null
  
)

export default component.exports